import { PrioritizationCriterionBase } from './base/prioritization-criterion-base';

export class PrioritizationCriterion extends PrioritizationCriterionBase { }